export const affiliateListItemStyles = {
  display: 'flex',
  marginBottom: '5px',
};

export const affiliateListStyleStyles = {};

export const affiliateListToolTipStyles = {
  marginRight: '8px',
};

export const affilliatePermissionListItemStyles = {
  display: 'grid',
  gridTemplateColumns: '45px auto',
  gridTemplateRows: '1fr',
};

export const affilliatePermissionListItemCheckBoxStyles = {
  gridColumnEnd: 1,
  gridColumnStart: 1,
  gridRowEnd: 2,
  gridRowStart: 1,
};

export const affilliatePermissionListItemLabelStyles = {
  gridColumnEnd: 2,
  gridColumnStart: 2,
  gridRowEnd: 1,
  gridRowStart: 2,
};

export const boxStylesStyles = theme => ({
  '& > span': {
    marginTop: '1px',
    padding: 0,
  },
  '& > span > div': {
    marginBottom: 0,
  },
  '&:first-child': {
    marginRight: theme.spacing(0.5),
  },
  alignItems: 'center',
  borderRadius: 4,
  display: 'flex',
  height: 20,
  justifyContent: 'center',
  padding: 2,
  width: 30,
});

export const cellStyles = theme => ({
  '& > p': {
    '&:last-child': {
      marginRight: 0,
    },
    marginRight: theme.spacing(1),
  },
  '& > span': {
    display: 'block',
    fontSize: 16,
  },
  '&:first-child': {
    '&:before': {
      content: 'none',
    },
    borderLeft: 'none',
    left: 0,
    position: 'sticky',
    width: '400px',
    zIndex: 1,
  },
  '&:nth-child(even)': {
    borderLeft: 'none',
    borderRight: 'none',
  },
  alignItems: 'center',
  borderLeft: '1px solid rgba(0, 0, 0, 0.13)',
  borderRight: '1px solid rgba(0, 0, 0, 0.13)',
  display: 'flex',
  height: 48,
  justifyContent: 'center',
  padding: theme.spacing(0, 1),
  width: 194,
  [theme.breakpoints.down('sm')]: {
    width: 168,
  },
});

export const cellLgStyles = {
  width: 225,
};

export const cellNoMarginStyles = {
  '& > label': {
    margin: 0,
  },
};

export const drawerStyles = theme => ({
  backgroundColor: theme.palette.surface.light,
  top: 0,
  width: '35vw',
});

export const drawerBodyStyles = {
  padding: '0 18px 18px 50px',
};

export const drawerButtonStyles = theme => ({
  color: theme.palette.secondary.main,
});

export const drawerTopBarStyles = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: 18,
  paddingRight: 0,
};

export const featurePermissionsStyles = {
  display: 'grid',
  gridTemplateColumns: '250px 65px auto',
  gridTemplateRows: '1fr 1fr',
  marginTop: '1rem',
};

export const featurePermissionsListHeaderStyles = {
  lineHeight: '1.9',
};

export const featurePermissionsListItemStyles = {};

export const featurePermissionsListItemDividerStyles = {
  gridColumnEnd: 4,
  gridColumnStart: 1,
};

export const keyStyles = theme => ({
  alignItems: 'center',
  columnGap: theme.spacing(1),
  display: 'grid',
  gridTemplateColumns: '30px auto',
  marginBottom: 0,
  marginLeft: theme.spacing(3),
});
